import AggregableDataModel from '../aggregable/AggregableDataModel';

export default class GeneralDataModel extends AggregableDataModel {
}